
export default {
  props: {
    categories: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    topCategories() {
      const categories = [...this.categories]
        .sort((a, b) => a.id - b.id)
        .slice(0, 5)
      return categories
    }
  }
}
